import { FC } from 'react'

export const ShareIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 0C10.3432 0 9 1.34695 9 3.00862C9 4.67029 10.3432 6.01754 12 6.01754C13.6569 6.01754 15.0001 4.67029 15.0001 3.00862C15.0001 1.34695 13.6569 0 12 0Z"
      fill="white"
    />
    <path
      d="M5.13041 7.75515L9.26711 5.49473C8.91344 5.10409 8.63886 4.63964 8.47644 4.12471L4.45106 6.56363C3.97917 6.09131 3.32804 5.7994 2.60892 5.7994C1.16805 5.7994 0 6.97055 0 8.41573C0 9.86065 1.16805 11.0318 2.60886 11.0318C4.04943 11.0318 5.21748 9.86065 5.21748 8.41573C5.21748 8.18705 5.18531 7.96677 5.13041 7.75515Z"
      fill="white"
    />
    <path
      d="M10.4348 10.5524C9.80018 10.5524 9.22941 10.8213 8.82525 11.2496L5.74717 9.44638C5.61434 9.85195 5.40648 10.2233 5.13867 10.5435L8.29207 12.2119C8.24488 12.3926 8.21728 12.5809 8.21728 12.7762C8.21728 14.0043 9.21001 15 10.4348 15C11.6593 15 12.6521 14.0043 12.6521 12.7762C12.6521 11.5481 11.6593 10.5524 10.4348 10.5524Z"
      fill="white"
    />
  </svg>
)
